(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interactive-map"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  document.getElementById('svg-container').style.display = 'block';

  const continents = {
    "europe": {
        name: "Europe",
        url: "/collections/europe",
        images: [
            "{{ 'europe-image-1.jpg' | asset_url }}",
            "{{ 'europe-image-2.jpg' | asset_url }}",
            "{{ 'europe-image-3.jpg' | asset_url }}"
        ]
    }
    // Additional continents can be added here
  };

  function showPopup(continentId) {
    const continent = continents[continentId];
    if (!continent) return;
    const imagesHTML = continent.images.map(image => `<img src="${image}" alt="${continent.name}" class="continent-image">`).join('');
    document.getElementById('popup-content').innerHTML = `<div class="popup-header"><h2>${continent.name}</h2></div><div class="popup-images">${imagesHTML}</div><button id="popup-button">Explore</button>`;
    document.getElementById('popup').style.display = 'flex';
    document.getElementById('popup-button').onclick = function() {
      window.location.href = continent.url;
    };
  }

  Object.keys(continents).forEach(continentId => {
    document.getElementById(continentId)?.addEventListener('click', function() {
      showPopup(continentId);
    });
  });

  document.getElementById('close-popup').onclick = function() {
    document.getElementById('popup').style.display = 'none';
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
